<script setup>
import MailjetForm from '@frontJs/components/forms/projectManagement/customers/externalServices/MailjetForm.vue';
import ProjectManagementLayout from '@frontJs/layouts/ProjectManagementLayout.vue';
import { Head } from '@inertiajs/vue3';
import PageTitle from '@js/components/titles/PageTitle.vue';

const { tenant, externalService } = defineProps({
    tenant: {
        type: Object,
        required: true,
    },
    externalService: {
        type: Object,
        required: true,
    },
});

defineOptions({ layout: ProjectManagementLayout });
</script>

<template>
    <Head>
        <title>
            Mailjet - Services externes - Clients - Gestion de projet -
            Datakepler
        </title>
    </Head>

    <PageTitle :tenant-name="tenant.name">
        Gestion de projet - Clients - Services externes - Mailjet
    </PageTitle>

    <MailjetForm :tenant="tenant" :external-service="externalService" />
</template>
